<template>
  <v-card
    class="ma-0 pt-0"
    width="100%"
    flat
  >
    <v-row class="mx-0 mt-2">
      <v-col
        class="pt-1 px-2"
        cols="6"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              height="32"
              width="32"
              style="min-width: 20px !important;margin-right: 2px !important;"
              color="primary"
              class="float-left me-2"
              v-on="on"
              @click="searchIntegrator"
            >
              <v-icon
                style="font-size: 24px"
              >
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('search') }} (enter)</span>
        </v-tooltip>
        <v-text-field
          ref="refSearchBarcode"
          v-model="searchBarcode"
          height="20"
          dense
          outlined
          autofocus
          clearable
          hide-details
          :label="$t('barcode/otherFields')"
        />
      </v-col>
      <v-col
        class="pt-1 px-2"
        cols="6"
      >
        <!--aslesh in offline bod-->
        <!-- <offlineProductAutocomplete
          v-model="productIntegratorValueName"
          title="productName"
          type="product"
          @setblur="setBlur"
        /> -->
        <autocomplete
          v-model="productIntegratorValueName"
          title="productName"
          type="product"
          @setblur="setBlur"
        />
      </v-col>
<!--      <v-col-->
<!--        class="pt-1 px-2"-->
<!--        cols="4"-->
<!--      >-->
<!--        <offlineProductAutocomplete-->
<!--          v-model="productIntegratorValueCode"-->
<!--          title="productCode"-->
<!--          type="productCode"-->
<!--          @setblur="setBlur"-->
<!--        />-->
<!--      </v-col>-->
    </v-row>
    <v-row class="mx-0 mt-2">
      <page-shortcut
        v-model="productShortcutItem"
        @append="add"
      />
    </v-row>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="300px"
      >
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet = !sheet"
        >
          {{ $t('close') }}
        </v-btn>
        <v-row class="mx-0">
          <v-col
            class="mb-0 pb-0 "
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <aicomplete
              ref="refGroup"
              v-model="group"
              :val="group"
              title="main-group"
              type="productGroup"
              :data="JSON.stringify({parent:0})"
              :new-btn="true"
            />
          </v-col>
          <v-col
            class="mb-0 pb-0 "
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <aicomplete
              ref="refCat1"
              v-model="cat1"
              :val="cat1"
              title="other-group"
              type="productGroup"
              :data="JSON.stringify({parent:(group?group.id:null)})"
              :new-btn="true"
            />
          </v-col>
          <v-col
            class="mb-0 pb-0 "
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <aicomplete
              ref="refCat2"
              v-model="cat2"
              :val="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({parent:(cat1?cat1.id:null)})"
              :new-btn="true"
            />
          </v-col>
        </v-row>
        <!--        <v-row class="mx-0">-->
        <!--          <v-col-->
        <!--            cols="12"-->
        <!--            sm="1"-->
        <!--            class="mb-1"-->
        <!--            md="1"-->
        <!--          >-->
        <!--            <v-switch-->
        <!--              v-model="availableGoods"-->
        <!--              :label="$t('only-available-goods')"-->
        <!--            />-->
        <!--          </v-col>-->
        <!--        </v-row>-->
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog
      v-model="productDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="productDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <product
              v-model="newProduct"
              form-type="product"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
    />
  </v-card>
</template>

<script>
  import Product from '../../../pages/product/product'
  var connection = new window.JsStore.Connection()
  export default {
    components: {
      aicomplete: () => import('../AIcomplete/index'),
      offlineProductAutocomplete: () => import('./offlineProductAutocomplete.vue'),
      pageShortcut: () => import('./productShortcut.vue'),
      Snakbar: () => import('../snakbar/snakbar'),
      Product,
    },
    props: ['header', 'customer', 'data', 'heightProp', 'itemCount', 'typeProp', 'scaleProp'],
    data () {
      return {
        timer: 0,
        page: 0,
        prevInput: null,
        searchBarcode: null,
        showImage: false,
        selectByBarcode: true,
        productShortcutItem: null,
        productIntegratorValueBarcode: null,
        productIntegratorValueName: null,
        productIntegratorValueCode: null,
        last_page: 1,
        offline: false,
        options: {
          locale: 'en-US',
          prefix: '',
          suffix: '  ریال  ',
          precision: 0,
        },
        feeRules: [
          v => !!v || 'Name is required',
          v => (v && v > 0) || 'Name must be less than 10 characters',
        ],
        productTimer: 0,
        listHeight: 360,
        searchCount: 0,
        heightSelectProduct: null,
        snakbarText: null,
        groups: null,
        selectGroup: null,
        showAlert: false,
        productDialog: false,
        disabled: false,
        taxDialog: false,
        snakbar: false,
        sumDiscountPercent: null,
        bottomPanel: null,
        date: null,
        snakbarColor: null,
        trip: {
          name: '',
          location: null,
          start: null,
          end: null,
        },
        locations: ['Australia', 'Barbados', 'Chile', 'Denmark', 'Ecuador', 'France'],
        items: [],
        bottomSummeryHeight: 'auto',
        selected: 0,
        selectedItem: [],
        searchTrigger: false,
        showSelectedItem: false,
        submitLoading: false,
        newProduct: null,
        searchTemp: null,
        group: null,
        disableSearch: false,
        cat1: null,
        cat2: null,
        search: null,
        list: null,
        type: 'productService',
        loading: false,
        sheet: false,
        bottomSummery: false,
        availableGoods: false,
        sumPrice: 0,
        sumDiscount: 0,
        sumTax: 0,
        lastPage: true,
        more: true,
        tax: false,
        write: false,
        discountRules: [
          v => (v && v <= 100) || 'Max should not be above £50,000',
        ],
      }
    },
    watch: {
      productIntegratorValueBarcode (val) {
        if (val) {
          this.add(val)
        }
      },
      productShortcutItem (val) {
        if (val) {
          this.add(val)
        }
      },
      productIntegratorValueName (val) {
        if (val) {
          this.add(val)
        }
      },
      productIntegratorValueCode (val) {
        if (val) {
          this.add(val)
        }
      },
      selectGroup (Val, oldVal) {
        this.page = 0
        this.items = []
        // this.selectByBarcode = false
        this.group = null
        if (this.selectGroup) {
          this.group = this.selectGroup
        }
        if (this.offline) {
          this.getItemsOffline()
        } else {
          this.getItemsOffline()
        }
      },
      group (Val, oldVal) {
        if (this.$refs.refCat2 && this.$refs.refCat1) {
          if (Val) {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
            this.$refs.refCat1.initList = false
            // this.$refs.refCat1.getItems()
          } else {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
          }
        }
      },
      cat1 (Val, oldVal) {
        if (this.$refs.refCat2) {
          if (Val) {
            this.$refs.refCat2.clear()
            this.$refs.refCat2.initList = false
            this.$refs.refCat2.getItems()
          } else {
            this.$refs.refCat2.clear()
          }
        }
      },
      data () {
      },
      newProduct  () {
        this.search = this.newProduct.name
        this.searchTrigger = true
        this.searchItems()
        this.productDialog = false
      },
      entrepot  () {
        this.search = ''
        // this.searchItems()
      },
      availableGoods () {
        this.items = []
        this.page = 0
        this.lastPage = 100000
        this.searchItems()
      },
      search (val, oldVal) {
        this.page = 0
        this.last_page = 0
        this.items = []
        if (!this.selectByBarcode) {
          if (this.offline) {
            this.getItemsOffline()
          } else {
            this.getItems()
          }
        }
      },
      productIntegratorValue (val, oldVal) {
        this.searchProductIntegrator()
      },
      selectByBarcode (val) {
        if (val) {
          this.selectGroup = null
        }
      },
      offline (val) {
        this.items = []
        if (val) {
          this.getItemsOffline()
        } else {
          this.getItems()
        }
        this.$emit('setOffline', val)
      },
      sheet () {
        if (this.sheet === false) {
          this.searchTrigger = true
          this.page = 0
          this.items = []
          this.lastPage = 100000
          this.initList = false
          this.getItems()
        }
      },
      scaleProp (val) {
        this.onResize()
      },
    },
    activated: function () {
      // this.countCheck()
    },
    mounted () {
      window.addEventListener('keydown', this.keyEvent)
      this.getGroups()
      // this.offline = true
      this.setDefaultCooki()
      if (this.offline) {
        // this.getItemsOffline()
      }
      this.DBCreate()
      // if (this.selectGroup) {
      //   this.items = []
      //   this.group = this.selectGroup
      // }
      // this.search = ''
    },
    beforeRouteLeave (to, from, next) {
      var goNext = false
      if (this.items) {
        this.items.map(function (value, key) {
          if (value.dialog) {
            value.dialog = false
            goNext = true
          }
        })
      }

      if (this.bottomPanel === 0) {
        this.bottomPanel = null
        goNext = true
      }
      if (!goNext) {
        next()
      } else {
        next(false)
      }
    },
    created () {
      // window.addEventListener('resize', this.resizeHeightBody)
    },
    destroyed () {
      // window.removeEventListener('resize', this.resizeHeightBody)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      keyEvent () {
        if (!this.$store.state.autoFocus) {
          return false
        }
        var app = this
        this.write = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          // app.$refs.refSearchBarcode.focus()
          app.write = false
        }, 3000)
      },
      setBlur () {
        // this.$store.commit('SET_AUTOFOCUS', true)
        // this.$refs.refSearchBarcode.focus()
      },
      setFocus () {
        // var app = this
        // if (!this.write && this.$store.state.autoFocus) {
        //   clearTimeout(this.timer)
        //   this.timer = setTimeout(function () {
        //     app.$refs.refSearchBarcode.focus()
        //   }, 3000)
        // }
      },
      beep () {
        var snd = new Audio('data:audio/wav;base64,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')
        snd.play()
      },
      twiceBeep () {
        var snd = new Audio('data:audio/mpeg;base64,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')
        snd.play()
        snd.play()
      },
      searchIntegrator(event) {
        var search = this.searchBarcode;
        this.searchBarcode = null;
        var isDB = localStorage.getItem('dbCreated');
        if (isDB && isDB === 'active' && search) {
          var app = this;
          var connection = new window.JsStore.Connection();
          connection.openDb('db_' + this.$store.state.userId);

          // جستجو در جدول محصولات
          connection.select({
            from: 'products',
            where: {
              barcode: search,
            },
          }).then(function (data) {
            if (data && data.length > 0) {
              app.add(data[0]);
              app.searchBarcode = null;
              app.beep();
            } else {
              // جستجو در جدول بارکد محصولات
              connection.select({
                from: 'productBarcodes',
                where: {
                  value: search,
                },
                join: {
                  with: 'products',
                  on: 'products.id = productBarcodes.product_id',
                  type: 'inner',
                  select: [
                    'products.id as productId', 'products.name', 'productBarcodes.value as barcodeValue'
                  ],
                },
              }).then(function (data) {
                if (data && data.length > 0) {
                  app.add(data[0]);
                  app.searchBarcode = null;
                  app.beep();
                } else {
                  app.twiceBeep();
                }
              });
            }
          });
        }
      },
      searchIntegratorOld (event) {
        var search = this.searchBarcode
        this.searchBarcode = null
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active') {
          var app = this
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.select({
            from: 'products',
            where: {
              barcode: search,
            },
          }).then(function (data) {
            if (data && data.length > 0) {
              app.add(data[0])
              app.searchBarcode = null
              app.beep()
            } else {
              app.twiceBeep()
            }
          })
          // connection.select({
          //   from: 'products',
          //   join: {
          //     with: 'productIntegrator',
          //     on: 'products.id=productIntegrator.product_id',
          //     type: 'inner',
          //     where: {
          //       value: {
          //         like: '%' + (search || '') + '%',
          //       },
          //     },
          //   },
          //   groupBy: 'product_id',
          // })
          //   .then(function (data) {
          //     if (data && data.length > 0) {
          //       app.add(data[0])
          //       app.searchBarcode = null
          //     }
          //   })
        }
      },
      searchProductIntegrator () {
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active') {
          var app = this

          connection.openDb('db_' + this.$store.state.userId)
          connection.select({
            from: 'products',
            join: {
              with: 'productIntegrator',
              on: 'products.id=productIntegrator.product_id',
              type: 'inner',
              where: {
                value: {
                  like: '%' + (app.productIntegratorValue ? app.productIntegratorValue : '') + '%',
                },
              },
            },
            groupBy: 'product_id',
          }).then(function (data) {
            app.items = data
          })
        }
      },
      onSearch (e) {
        if (e.code === 'Enter') {
          this.page = 0
          this.items = []
          this.last_page = 0
          if (this.search === this.searchTemp) {
            this.searchCount++
          } else {
            this.searchCount = 1
          }
          this.searchTemp = this.search
          if (this.offline) {
            this.search = null
            this.getItemsOffline()
          } else {
            this.getItems()
          }
        }
      },
      onResize () {
        var minus = 120
        var minusDesctop = 321
        if (window.innerHeight < 800) {
          minus = 260
        }
        if (this.scaleProp) {
          minus = 240
          minusDesctop = 275
        }
        this.heightSelectProduct = (this.isMobile ? window.outerHeight - minus : window.outerHeight - minusDesctop)
      },
      clearSearch () {
        this.initList = false
        this.getItems()
      },
      add (item) {
        this.loading = false
        this.$emit('append', item)
      },
      visibilityChanged (e) {
        if (this.page > 0) {
          if (this.offline) {
            e && this.getItemsOffline()
          } else {
            e && this.getItems()
          }
        }
      },
      getItems () {
        var timeout = 1000
        if (this.page === 0) {
          this.page = 1
        }
        if (this.selectByBarcode) {
          timeout = 50
        }
        this.loading = true
        this.showAlert = false
        if (this.page === 1 && this.search == null && this.searchTemp == null && this.initList && this.selectByBarcode) {
          return false
        }
        this.initList = true
        var app = this
        clearTimeout(this.productTimer)
        this.productTimer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              search: (app.selectByBarcode ? app.searchTemp : app.search),
              page: app.page,
              count: 25,
              select: 'productService',
              formType: app.typeProp,
              currency: app.currency,
              data: app.data,
              parent_id: app.parent,
              group: (app.group ? app.group.id : null),
              cat1: (app.cat1 ? app.cat1.id : null),
              cat2: (app.cat2 ? app.cat2 : null),
            },
          })
            .then(res => {
              res = res.data
              var setDef = false
              if (app.setInit && app.page === 1) {
                app.items = []
                setDef = true
              }
              app.last_page = res.last_page
              var search = (app.selectByBarcode ? app.searchTemp : app.search)
              if (!search && app.items && app.items.length > 0) {
                app.items = [
                  ...app.items,
                  ...Array.from(res.data),
                ]
              } else {
                app.items = res.data
              }
              if (app.items && res.total > app.items.length) {
                app.page++
              }
              if (res.last_page === res.current_page) {
                app.last_page = 1
                app.more = false
              }
              if (setDef) {
                app.model = app.items[0]
              }
              if (res.data && res.data.length > 0) {
                app.notFind = null
                if (app.selectByBarcode && app.items.length === 1) {
                  app.add(app.items[0])
                  app.search = null
                }
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(function () {
              app.disabled = false
              app.loading = false
              if (app.items && app.items.length === 0) {
                app.showAlert = true
                if (app.selectByBarcode) {
                  setTimeout(function () {
                    app.search = null
                  }, 1500)
                }
              }
            })
        }, timeout)
      },
      getGroups () {
        this.loading = true
        var app = this
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            search: app.search,
            select: 'allProductGroup',
          },
        })
          .then(res => {
            res = res.data
            app.groups = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            if (app.items && app.items.length === 0) {
              app.showAlert = true
              if (app.selectByBarcode) {
                setTimeout(function () {
                  app.search = null
                }, 1500)
              }
            }
            app.loading = false
          })
      },
      getItemsOffline () {
        var isDB = localStorage.getItem('dbCreated')
        if (isDB && isDB === 'active') {
          var count = (this.showImage ? 12 : 24)
          var app = this
          var connection = new window.JsStore.Connection()
          var group = (app.group ? [app.group.id] : null)
          connection.openDb('db_' + this.$store.state.userId)
          connection.count((group ? {
            from: 'products',
            where: {
              name: {
                like: '%' + (app.search ? app.search : '') + '%',
              },
              group_id: { in: group },
            },
          }
            : {
              from: 'products',
              where: {
                name: {
                  like: '%' + (app.search ? app.search : '') + '%',
                },
              },
            })).then(function (data) {
            app.last_page = Math.ceil(data / count)
          })
          connection.select((group ? {
            from: 'products',
            skip: app.page * count,
            limit: count,
            where: {
              name: {
                like: '%' + (app.search ? app.search : '') + '%',
              },
              group_id: { in: group },
            },
          }
            : (app.selectByBarcode && app.searchTemp ? {
              from: 'products',
              skip: app.page * count,
              limit: count,
              where: {
                barcode: {
                  like: '%' + app.searchTemp + '%',
                },
                or: {
                  code: {
                    like: '%' + app.searchTemp + '%',
                  },
                },
              },
            }
              : {
                from: 'products',
                skip: app.page * count,
                limit: count,
                where: {
                  name: {
                    like: '%' + (app.search ? app.search : '') + '%',
                  },
                },
              }
            ))).then(function (data) {
            if (app.last_page > app.page) {
              app.page++
            }
            if (app.page === 0) {
              app.items = []
            }
            app.items = [
              ...app.items,
              ...data,
            ]
            if (app.selectByBarcode && app.items.length === 1) {
              app.items[0].count = app.searchCount
              app.add(app.items[0])
              app.searchTemp = null
              app.searchCount = 0
              app.search = null
            }
          })
        }
      },
      async DBCreate1 () {
        this.DB = new window.JsStore.Connection()
        var connection = this.DB
        var userId = this.$store.state.userId
        var invoice = {
          name: 'invoice',
          columns: {
            id: { dataType: 'number' },
            accountId: { dataType: 'number' },
            date: { dataType: 'string' },
            type: { dataType: 'string' },
            ouid: { dataType: 'string' },
            store: { dataType: 'boolean' },
          },
        }
        var products = {
          name: 'products',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
            barcode: { dataType: 'string' },
            code: { dataType: 'number' },
            group_id: { dataType: 'number' },
            count: { dataType: 'number' },
          },
        }
        var person = {
          name: 'person',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
            mobile: { dataType: 'string' },
            phone: { dataType: 'string' },
            address: { dataType: 'string' },
            remain: { dataType: 'number' },
          },
        }
        var entrepot = {
          name: 'entrepot',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var branch = {
          name: 'branch',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var currency = {
          name: 'currency',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var productGroup = {
          name: 'productGroup',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var db = {
          name: 'db_' + userId,
          tables: [products, person, entrepot, branch, productGroup, currency, invoice],
        }
        var isDbCreated = await connection.initDb(db)
        if (isDbCreated) {
          // alert('Db Created & connection is opened')
        } else {
          // alert('Connection is opened')
        }
      },
      getItemsOffline1 () {
        var timeout = 10
        if (this.selectByBarcode) {
          timeout = 60
        }
        var app = this
        app.loading = true
        var search = (app.selectByBarcode ? app.searchTemp : app.search)
        clearTimeout(this.productTimer)
        this.productTimer = setTimeout(async function () {
          var products = JSON.parse(localStorage.getItem('products'))
          if (app.selectGroup && products) {
            products = products.filter(function (product) {
              return product.group_id === app.selectGroup.id
            })
          }
          if (search && products) {
            products = products.filter(function (product) {
              return product.name.includes(search) || product.code === parseFloat(search) || product.barcode === search
            })
          }
          app.last_page = Math.ceil((products ? products.length / 5 : 1))
          if (app.selectByBarcode && search) {
            app.items = products
          } else {
            if (products) {
              app.items = [
                ...app.items,
                ...app.paginate(products, (app.selectByBarcode && search ? 1 : 12), app.page),
              ]
            } else {
              app.last_page = 0
            }
          }
          if (app.items.length > 0) {
            app.notFind = null
            if (app.selectByBarcode && app.items.length === 1) {
              app.items[0].count = app.searchCount
              app.add(app.items[0])
              app.searchTemp = null
              app.searchCount = 0
              app.search = null
            }
          }
          app.loading = false
        }, timeout)
      },
      setSearchFocus () {
        // var app = this
        // if (!this.write && this.$store.state.autoFocus) {
        //   clearTimeout(this.timer)
        //   this.timer = setTimeout(function () {
        //     app.$refs.refSearchBarcode.focus()
        //   }, 3000)
        // }
        this.$refs.refSearchBarcode.focus()
      },
    },
  }
</script>

<style>
  .product-item-category {
    border: 1px solid #e3e3e3;
    border-radius: 5px;
  }
  .dense > .v-input__control {
    min-height: 30px !important;
  }
  .border-item {
    border: #0066FF solid 1px;
  }
  .bottomSummery {
    position: fixed;
    height: auto;
    bottom: 0;
    width: 100%;
  }
</style>
